import React, { Component } from 'react'
import {Rectangle} from 'react-shapes';
import Typography from '@material-ui/core/Typography';
import {font} from '../CSS/font'
import { withStyles } from '@material-ui/core/styles'

const styles = {...font}

class horizontalBar extends Component {
	render() {
		let { classes } = this.props

		let positionX = this.props.X
		let positionY = this.props.Y
		let textY = (this.props.height - font.bar_text.fontsizeint)/2
		let width = this.props.length
		let fillColor = this.props.fillColor == null ? '#ffffff' : this.props.fillColor
		let strokeColor = this.props.strokeColor == null ? '#000000' : this.props.strokeColor
		let strokeWidth = this.props.strokeWidth == null ? 1 : this.props.strokeWidth
		let height = this.props.height == null ? 40 : this.props.height
		return (
        	<div style={{position:'absolute', top: positionY+'px', left: positionX+'px'}}>
        	    <Typography 
	        	    className={classes.bar_text} 
	        	    style={{position: 'absolute', left: '2px', top: textY+'px'}} 
	        	    className = {classes.font_family}
	        	>
	        	    {this.props.label}
        	    </Typography>
        	    <Rectangle 
	        	    width={width} 
	        	    height={height} 
	        	    fill={{color:fillColor}} 
	        	    stroke={{color:strokeColor}} 
	        	    strokeWidth={strokeWidth} 
        	    />
        	</div>
        )
    }
}
export default withStyles(styles)(horizontalBar);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/horizontalBar.js